export const SORT_DIRECTIONS = {
    NONE: "none",
    ASC: 0,
    DESC: 1
}

export const ROW_SELECTION_OPTIONS = [
    { label: "5 Rows", value: 5 },
    { label: "10 Rows", value: 10 },
    { label: "20 Rows", value: 20 },
    { label: "50 Rows", value: 50 },
    { label: "100 Rows", value: 100 },
    { label: "200 Rows", value: 200 },
    { label: "1000 Rows", value: 1000 },
]